module.exports = __webpack_public_path__ + "img/tip_bubbles.31c8b378.png";